import React, { useReducer, createContext, useContext } from 'react';
import { PlayerUIReducer } from './reducer';
import { PlayerUIState } from './state';
const PlayerUIContext = createContext(null);
const PlayerUIContextProvider = ({ children }) => {
    const [state, dispatch] = useReducer(PlayerUIReducer, PlayerUIState);
    return (React.createElement(PlayerUIContext.Provider, { value: { state, dispatch } }, children));
};
PlayerUIContextProvider.displayName = 'PlayerUIContextProvider';
export const usePlayerUIContext = () => useContext(PlayerUIContext);
export * from './actions';
export { PlayerUIState, PlayerUIContextProvider, PlayerUIContext };
export const makePlayerUIContextTestHelper = () => {
    const shared = {
        state: PlayerUIState,
        dispatch: (_action) => undefined,
    };
    const Component = () => {
        const { state, dispatch } = usePlayerUIContext();
        shared.state = state;
        shared.dispatch = dispatch;
        return null;
    };
    return {
        Component,
        getState: () => shared.state,
        dispatch: (action) => shared.dispatch(action),
    };
};
//# sourceMappingURL=index.js.map